// The page side of the share link and the LINE banner (pure logic: src/share.js).
//   getDoc()   → the document to put into a link (what was asked for, valid or not)
//   onDoc(doc) → a link was opened and its document PASSED every check: take it over
// → loadFromHash(): read location.hash now (main.js calls it once at start; hashchange calls it after).
import { $ } from './dom.js';
import { shareUrl, readShareHash, isLineBrowser, externalBrowserUrl } from '../share.js';
import { S } from '../strings.js';

export function wireShare({ getDoc, onDoc, onShare }) {
  $('#btn-share').onclick = async () => {
    const url = shareUrl(location.href, getDoc());
    const box = $('#share-url'), note = $('#share-note');
    try {
      await navigator.clipboard.writeText(url);
      box.classList.add('hidden');
      note.textContent = S.copied;
    } catch {                                                      // no clipboard (old WebView, permission refused): show the link itself
      box.value = url; box.classList.remove('hidden'); box.focus(); box.select();
      note.textContent = S.copyManual;
    }
    onShare?.();                                                   // fired either way — a link was produced and shown/copied
  };

  // A link is input from strangers: readShareHash() returns a checked document or an error — on an
  // error NOTHING changes except the message.
  function loadFromHash() {
    const r = readShareHash(location.hash);
    if (!r) return;
    if (r.error) { $('#link-note-text').textContent = r.error.code === 'newer-version' ? S.link.newer : S.link.bad; $('#link-note').classList.remove('hidden'); return; }
    $('#link-note').classList.add('hidden');
    onDoc(r.doc);
  }
  $('#link-note-close').onclick = () => $('#link-note').classList.add('hidden');
  window.addEventListener('hashchange', loadFromHash);

  // LINE's in-app browser cannot download: offer its way out, and take the design along in the fragment.
  if (isLineBrowser(navigator.userAgent)) {
    $('#line-banner').classList.remove('hidden');
    $('#line-open').onclick = () => { location.href = externalBrowserUrl(shareUrl(location.href, getDoc())); };
  }
  return loadFromHash;
}
